module.exports = __webpack_public_path__ + "img/freight_yard1_1.ca8f31a4.png";